<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="img5a"><img alt="art" src="images/line.jpg"/></p>
<h1 class="acknowledgments-title">Acknowledgments</h1>
<p class="noindent">This book has been a joy to research and write from start to finish. For that I have a legion of supporters to thank.</p>
<p>To Jay Acton, for coming up with the idea and selling it to George Witte, my esteemed editor at St. Martin’s Press. To Neil and Dawn Reshen, my business managers, for their bulldogged support and encouragement. I love you both.</p>
<p>To the staffs of the public libraries in New York, Chicago, Tampa, and St. Petersburg, as well as to the librarians of the Chicago Historical Society. To Mark Rifkin, a copy editor of extraordinary ability. Thank you all.</p>
<p>To Bill Young, for pointing me in the right directions.</p>
<p>To my family: the lovely Rhonda, the wonderful Charlie, the bassetty Doris.</p>
<p>To Marty Appel for being kind enough to photocopy King Kelly’s book and send it to me; to Paul Bauer, for lending me a copy of Johnny Evers’s rare book.</p>
<p>To the late Ed Froelich: it was a privilege having known you. To Woody English and Phil Cavarretta, fine gentlemen, thanks for your many hours of recollections.</p>
<p>To Randy Hundley, for allowing me to come to your Cub fantasy camp to interview you and your teammates, Glenn Beckert, Gene Oliver, Ron Santo, and Ferguson Jenkins and allowing me to see the true nature of Cubworld.</p>
<p>Also my deep appreciation to former Cubs players Billy Jurges, the late Billy Herman, Bill Nicholson, Ken Raffensberger, Henry Wyse, Don Johnson, Lennie Merullo, Dewey Williams, the late Don Elston, childhood hero Jim Brosnan, Darold Knowles, Dickie Noles, Bruce Sutter, and Rick Sutcliffe.</p>
<p>To Cubs fans Paul and Ned Buchbinder, Jim Shapiro, and Bruce Ladd, and to Jack Wiers, my former announcing partner with the St. Petersburg Pelicans. You said Chicago was a great city. You were right.</p>
<p>To Al Spalding, Cap Anson, Mike Kelly, and Johnny Evers. Your books allowed me to succeed beyond my wildest dreams.</p>
<p>And finally, to the truest, purest fans in the world, the millions who love the Cubs, win or lose. The rest of society could learn a thing or two from your approach to life. This big fat book is for you.</p>
<p>When the Cubs win their next pennant, I’ll be cheering too.</p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?67c0003e